import React, { useContext } from "react";
import { QuestionSection, RadioRange } from "../../components/utility/quote";
import { navigate } from "gatsby-link";

import HardwareContext from "../../contexts/hardwareContext";
import { Asap, Within1, Within12, Within3, Within6 } from "../../svgs/asap";

const Next = "/hardware/Questions/4";
const Points = [
  {
    question: "What is your project timeframe?",
    progress: "70%",
    options: [
      {
        answer: "Within 1 month",
        to: Next,
        icon: <Within1 />,
      },
      { answer: "Within 3 months", to: Next, icon: <Within3 /> },
      { answer: "Within 6 months", to: Next, icon: <Within6 /> },
      { answer: "Within 12 months", to: Next, icon: <Within12 /> },
      { answer: "As soon as possible", to: Next, icon: <Asap /> },
    ],
  },
];

export default function Question3({ title }) {
  const { que3, setQue3 } = useContext(HardwareContext);

  return Points.map((item) => {
    return (
      <QuestionSection
        title={title}
        question={item.question}
        progress={item.progress}
      >
        {item.options.map((items) => {
          return (
            <RadioRange
              key={items.answer}
              icon={items.icon}
              value={items.answer}
              title={items.answer}
              isSelected={que3 === items.answer}
              onChange={(e) => {
                setQue3(e.target.value);
                navigate(items.to);
              }}
            />
          );
        })}
      </QuestionSection>
    );
  });
}
